<template>
    <div class="erm_wrapper">
        <div class="template_settings_top_navbar">
            <div class="erm_left_navbar">
                <div class="erm_shortcode">
                    <router-link to="#">
                        [erm_templates]
                    </router-link>
                </div>
                <div class="erm_custom_mode">
                    <el-radio-group v-model="mode">
                        <el-radio-button value="settings">Settings</el-radio-button>
                        <el-radio-button value="preview">Preview</el-radio-button>
                    </el-radio-group>
                </div>
            </div>
            <div class="erm_right_navbar">
                <button @click="saveColor">Save Settings</button>
            </div>
        </div>
        <div class="template_settings_header" v-if="mode == 'settings'">
            <div class="template_setting">
                <div class="erm_flex" style="margin-bottom: 20px;">
                    <div class="choose_color">
                        <el-tooltip class="box-item"
                            content="Select a layout style for your menu. Each template offers a unique visual experience."
                            placement="top-start">
                            <div class="demonstration">
                                Choose Template
                                <el-icon><InfoFilled /></el-icon>
                            </div>
                        </el-tooltip>
                        <el-select v-model="settings.template">
                            <el-option value="standard">Standard</el-option>
                            <el-option value="classic">Classic</el-option>
                        </el-select>
                    </div>
                </div>
                <div class="settings_item">
                    <el-tooltip class="box-item"
                        content="Enabling this option adds a 'Details' action button to the menu item, allowing users to view a dedicated details page for that item."
                        placement="top-start">
                        <div class="demonstration">
                            Allow menu single page 
                            <el-icon><InfoFilled /></el-icon>
                        </div>
                    </el-tooltip>
                    <el-switch class="enable_details_btn" active-value="yes" inactive-value="no" active-text="Enable"
                        v-model="settings.menu_single_page" />
                </div>
                <div class="settings_item">
                    <el-tooltip class="box-item"
                        content="Enter a title for this menu category. This title appears when using the category shortcode. Leave it empty to hide the title."
                        placement="top-start">
                        <div class="demonstration">
                            Category Title
                            <el-icon><InfoFilled /></el-icon>
                        </div>
                    </el-tooltip>
                    <el-input v-model="settings.category_title" />
                </div>
                <div class="settings_item">
                    <el-tooltip class="box-item"
                        content="Set the main heading for your restaurant’s menu. This title will be displayed on the menu section. Leave it empty to hide the title."
                        placement="top-start">
                        <div class="demonstration">
                            Menu Title
                            <el-icon><InfoFilled /></el-icon>
                        </div>
                    </el-tooltip>
                    <el-input v-model="settings.menus_title" />
                </div>
                <div class="settings_item">
                    <el-tooltip class="box-item"
                        content="Write a brief description of this category to highlight its uniqueness. This helps engage customers and improve SEO. Leave it empty to hide the short description."
                        placement="top-start">
                        <div class="demonstration">
                            Category Short Description
                            <el-icon><InfoFilled /></el-icon>
                        </div>
                    </el-tooltip>
                    <el-input v-model="settings.category_short_desc" />
                </div>
                <div class="settings_item">
                    <el-tooltip class="box-item"
                        content="Provide a short overview of your restaurant’s menu. This can attract customers by giving them an idea of what to expect. Leave it empty to hide the short description."
                        placement="top-start">
                        <div class="demonstration">
                            Menu Short Description
                            <el-icon><InfoFilled /></el-icon>
                        </div>
                    </el-tooltip>
                    <el-input v-model="settings.menus_short_desc" />
                </div>
            </div>
        </div>
        <div class="template_settings_body" :style="styles(settings)" v-else>
            <!-- <Classic /> -->
            <Standard v-if="settings?.template == 'standard'" :settings="settings" />
            <Classic v-if="settings?.template == 'classic'" :settings="settings" />
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import Icon from "../../../components/Icons/AppIcon.vue";
import Classic from './templates/Classic.vue';
import Standard from './templates/Standard.vue';
export default {
    components: {
        Icon,
        Classic,
        Standard
    },
    props: {
        settings: {
            type: Object,
            default: {}
        }
    },
    data() {
        return {
            loading: false,
            mode: 'settings',
            rest_api: window.RestaurantMenuMangeData.rest_api,
        }
    },
    methods: {

        styles(settings) {
            return {
                '--primary-color': settings?.primary_color,
                '--secondary-color': settings?.secondary_color,
                '--font-color': settings?.font_color,
                '--background-color': settings?.background_color,
                '--primary-light': `color-mix(in srgb, ${settings?.primary_color} 20%, white)`,
                '--font-light': `color-mix(in srgb, ${settings?.font_color} 60%, white)`
            };
        }
    },
    mounted() {
    }


}
</script>

<style lang="scss">
.template_settings_header,
.template_settings_body {
    padding: 20px;
    background: #fff;
    margin-bottom: 20px;
    border-radius: 8px;
}

.settings_item {
    margin-bottom: 20px;
    .demonstration {
        font-size: 16px;
        font-weight: 500;
        margin-bottom: 10px;
    }
    .el-input__wrapper {
        height: 38px;
    }
}

.template_setting {
    .choose_color {
        width: calc(25% - 15px);
        .demonstration {
            font-size: 16px;
            font-weight: 500;
            margin-bottom: 10px;
        }

        .enable_details_btn {
            margin-top: 8px;
        }
        .el-color-picker {
            width: 100% !important;
        }
        .el-color-picker__trigger {
            width: 100% !important;
        }

        .el-select__wrapper {
            width: 100% !important;
            height: 38px;
        }
    }
}

.template_settings_top_navbar {
    padding: 20px;
    background: #fff;
    margin-bottom: 20px;
    border-radius: 8px;
    display: flex;
    justify-content: space-between;
    text-align: center;

    .erm_left_navbar {
        display: flex;
        gap: 20px;
        align-items: center;

        .erm_shortcode {
            a {
                background: #e5e6e899;
                padding: 10px 12px;
                border-radius: 8px;
                font-size: 16px;
                color: #3C434A;
            }

        }

        .erm_custom_mode {
            background-color: #e5e6e899;
            display: flex;
            gap: 10px;
            align-items: center;
            font-size: 16px;
            padding: 6px 6px;
            border-radius: 8px;

            .erm_mode_item {
                color: #606266;
                border-radius: 6px;
                padding: 6px 12px;
            }

            .active {
                background-color: #fff;
                color: #3C434A;
                border-radius: 6px;
                padding: 6px 12px;
            }
        }
    }

    .erm_right_navbar {
        button {
            font-size: 16px;
            border: 1px solid #017EF3;
            background: #017EF3;
            color: #fff;
            padding: 8px 10px;
            border-radius: 8px;
            cursor: pointer;
            transition: all .3s;

            &:hover {
                background: #0165C2;
            }
        }
    }
}
</style>